import { Editor } from '@tinymce/tinymce-react';
import axios from 'axios';
import { EditorState } from 'draft-js';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Select from 'react-select';
import swal from 'sweetalert';
import undefsafe from 'undefsafe';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import CommissionLabel from '../../../components/CommissionLabel';
import SalePackageLabel from '../../../components/SalePackageLabel';
import Button from '../../../components/CustomButton/CustomButton';
import Upload from '../../../libCustom/upload';
import * as K from '../redux/QuotationsConstants';

const options = [
  { value: 'MXN', label: 'MXN' },
  { value: 'USD', label: 'USD' },
];

class packagesAdd extends Component {
  constructor(props) {
    super(props);

    this.formDataDefault = {
      name: '',
      description: '',
      price: 0,
      buyprice: 0,
      operator: '',
      currency: '',
      files: [],
    };

    this.state = {
      formData: this.formDataDefault,
      editorState: EditorState.createEmpty(),
      optionsSelect: {
        operators: [],
      },
      edit: '',
    };
  }

  componentWillMount() {
    this.getOptionsSelect(
      'operators',
      process.env.REACT_APP_URL_API + '/api/operators',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      },
    );
  }

  componentWillReceiveProps(nextProps) {
    var newForm = nextProps.Quotations.dataToEdit.packages;
    if (newForm.name !== undefined) {
      this.setState({
        edit: newForm,
        formData: newForm,
      });
    }
  }

  getOptionsSelect = async (name, url, optionCreateFunction) => {
    const response = await axios.get(url);

    const options = response.data
      .filter((option) => option.isDeleted !== true)
      .map(optionCreateFunction)
      .sort((a, b) => {
        const labelA = a.label.toLowerCase();
        const labelB = b.label.toLowerCase();
        return labelA.localeCompare(labelB);
      });

    this.setState({
      optionsSelect: {
        ...this.state.optionsSelect,
        [name]: options,
      },
    });
  };

  onCloseModal = () => {
    this.setState({
      formData: this.formDataDefault,
    });
    this.props.dispatch({
      type: K.CLOSE_MODAL_ADD,
      payload: 'packages',
    });
  };

  alertInfo = async (msg) => {
    await swal('Atención!!', msg, {
      icon: 'warning',
      timer: 2500,
      buttons: false,
    });
  };

  setPricesIfPackage = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        price: 0,
        buyprice: 0,
      },
    });
  };

  handledPrices = () => {
    if (this.formAdd.reportValidity()) {
      this.onAdd();
    }
  };

  onEditorStateChange = (editorState) => {
    var newFormData = immutable.set(
      this.state.formData,
      ['description'],
      editorState.target.getContent(),
    );
    this.setState({
      editorState,
      formData: newFormData,
    });
  };

  onAdd = () => {
    if (this.state.edit.name !== undefined) {
      this.props.dispatch({
        type: K.UPDATE_PACKAGE,
        payload: {
          data: {
            value: this.state.formData,
            index: this.props.Quotations.indexToEdit,
          },
        },
      });
      this.props.dispatch({
        type: K.CLOSE_MODAL_ADD,
        payload: 'packages',
      });
    } else {
      this.props.dispatch({
        type: K.ADD_PACKAGE,
        payload: this.state.formData,
      });
      this.props.dispatch({
        type: K.CLOSE_MODAL_ADD,
        payload: 'packages',
      });
    }
    this.setState({
      formData: this.formDataDefault,
    });
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  render() {
    const {
      Quotations: {
        modalAddStatus,
        generalQuotation: { isPackage = false },
      },
    } = this.props;
    const { formData, optionsSelect } = this.state;
    return (
      <div>
        <Modal
          open={undefsafe(modalAddStatus, 'packages') || false}
          onClose={this.onCloseModal}
          styles={{ modal: { width: '100%' } }}
          closeOnOverlayClick={false}
        >
          <div>
            <Grid fluid>
              <form
                ref={(ref) => {
                  this.formAdd = ref;
                }}
              >
                <Row>
                  <Col md={12}>
                    <h5>Agregar paquete</h5>
                    <SalePackageLabel isPackage={isPackage} />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="name" style={{ fontWeight: '400' }}>
                        NOMBRE
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={formData.name}
                        required
                        onChange={(event) =>
                          this.onChange('name', event.target.value)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label
                        htmlFor="description"
                        style={{ fontWeight: '400' }}
                      >
                        DESCRIPCIÓN
                      </label>
                      <Editor
                        apiKey="yh5rufshh2emoyv36klyisv3mwcmm4js3xqbjfaef7nf1yia"
                        init={{
                          min_height: 500,
                          plugins: 'link code table paste lists advlist',
                        }}
                        initialValue={formData.description}
                        onChange={this.onEditorStateChange}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="reference" style={{ fontWeight: '400' }}>
                        TIPO DE CAMBIO
                      </label>
                      <Select
                        placeholder="-- Seleccionar"
                        name="currency"
                        value={'MXN'}
                        options={options}
                        disabled={true}
                        onChange={(event) =>
                          this.onChange('currency', event.value)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="buyprice" style={{ fontWeight: '400' }}>
                        TARIFA NETA APROX.
                      </label>
                      <input
                        type="number"
                        min="1"
                        step="any"
                        className="form-control"
                        id="buyprice"
                        disabled={isPackage}
                        value={formData.buyprice}
                        onChange={(event) =>
                          this.onChange('buyprice', event.target.value)
                        }
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="price" style={{ fontWeight: '400' }}>
                        TARIFA PÚBLICA APROX.
                      </label>
                      <input
                        type="number"
                        min="1"
                        step="any"
                        className="form-control"
                        id="price"
                        disabled={isPackage}
                        value={formData.price}
                        onChange={(event) =>
                          this.onChange('price', event.target.value)
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <CommissionLabel
                  price={formData.price}
                  buyprice={formData.buyprice}
                  isPackage={isPackage}
                />
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <label htmlFor="operator" style={{ fontWeight: '400' }}>
                        OPERADOR
                      </label>
                      <Select
                        validate
                        required
                        placeholder="-- Seleccionar"
                        name="operator"
                        value={formData.operator}
                        options={optionsSelect.operators}
                        onChange={(value) => this.onChange('operator', value)}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <Upload
                        label={'ARCHIVOS'}
                        files={formData.files}
                        directory={'packs'}
                        bucket={'loopback-rsviajes'}
                        multiple={true}
                        onChange={(files) => {
                          this.onChange('files', files);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className={'pull-right'} style={{ marginBottom: 15 }}>
                      <Button
                        bsStyle="primary"
                        style={{ marginRight: 10 }}
                        onClick={this.onCloseModal}
                      >
                        Regresar
                      </Button>
                      <Button
                        bsStyle="primary"
                        fill
                        onClick={this.handledPrices}
                      >
                        Guardar
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </Grid>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(
  packagesAdd,
);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/packagesAdd.js